module.exports = __webpack_public_path__ + "img/kiribati.f0e76c98.svg";